import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'expenses-dialog',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './expenses-dialog.component.html',
  styleUrl: './expenses-dialog.component.scss',
})
export class ExpensesDialogComponent {
  @Input() active: boolean = false;
  @Input() data: any = '';
  @Input() siteType = '';
  @Input() siteSubType = '';
  @Input() address: any = { streetAddress: '', cityStateZip: '' };

  @Output() modalClosed = new EventEmitter<boolean>();
  @Output() saveExpenses = new EventEmitter<any>();

  editable: boolean = false;
  travelCost: number = 0;
  otherCost: number = 0;
  otherCostDescription: string = '';

  ngOnInit() {
    if (this.data?.proposal) {
      this.editable =
        this.data.proposal.status === 'INVITATION' ||
        this.data.proposal.status === 'OFFERED';

      this.travelCost = this.data.proposal.travelCost;
      this.otherCost = this.data.proposal.otherCost;
      this.otherCostDescription = this.data.proposal.otherCostDescription;
    }
  }

  closeDialog() {
    this.active = false;
    this.modalClosed.emit(this.active);
  }

  submit() {
    if (
      this.travelCost !== this.data.proposal.travelCost ||
      this.otherCost !== this.data.proposal.otherCost ||
      this.otherCostDescription !== this.data.proposal.otherCostDescription
    ) {
      if (!this.otherCost) {
        this.otherCostDescription = '';
      }
    }
    this.saveExpenses.emit({
      travelCost: this.travelCost,
      otherCost: this.otherCost,
      otherCostDescription: this.otherCostDescription,
    });
    this.closeDialog();
  }
}
